import { resolveRepoAbsPathFromBridge } from '../../git/tree/index.js';
import type { FileBrowserRequestMessage } from './types.js';

export type GitBranchScope = {
  repoAbsPath: string;
  branch: string;
};

export function resolveGitBranchScope(msg: FileBrowserRequestMessage): GitBranchScope | null {
  const gitBranchScope =
    msg.source === 'git_branch' &&
    typeof msg.repoRelPath === 'string' &&
    typeof msg.branch === 'string' &&
    msg.branch.trim().length > 0;
  if (!gitBranchScope) return null;
  const repoAbsPath = resolveRepoAbsPathFromBridge(msg.repoRelPath!);
  if (!repoAbsPath) return null;
  return { repoAbsPath, branch: msg.branch!.trim() };
}
